(function () {
	const header = document.querySelector('.site-header');
	if (!header) return;
	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function setHeaderHeight() {
		document.documentElement.style.setProperty('--pk-header-height', header.offsetHeight + 'px');
	}
	new ResizeObserver(setHeaderHeight).observe(header);

	function initNav() {
		const burger = header.querySelector('.nav-burger');
		const links = header.querySelector('.nav-links');
		if (!burger || !links) return;

		const backdrop = header.querySelector('.nav-backdrop');

		function setOpen(open) {
			links.classList.toggle('open', open);
			burger.setAttribute('aria-expanded', String(open));
			document.documentElement.style.overflow = open ? 'hidden' : '';
		}

		burger.addEventListener('click', () => setOpen(!links.classList.contains('open')));
		if (backdrop) backdrop.addEventListener('click', () => setOpen(false));
		links.querySelectorAll('a').forEach((a) => {
			a.addEventListener('click', () => setOpen(false));
		});
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && links.classList.contains('open')) {
				setOpen(false);
				burger.focus();
			}
		});
	}

	function initMenus() {
		header.querySelectorAll('.nav-links .has-menu').forEach((li) => {
			const top = li.querySelector('.menu-top');
			if (!top) return;
			top.addEventListener('click', (e) => {
				if (window.matchMedia('(max-width: 940px)').matches && top.tagName === 'A' && top.getAttribute('href')) return;
				if (window.matchMedia('(hover: none)').matches && !li.classList.contains('open')) {
					e.preventDefault();
					li.classList.add('open');
				}
			});
		});
	}

	function initHeaderTheme() {
		const probes = Array.from(document.querySelectorAll('[data-header]'));
		if (!probes.length) return;
		function update() {
			const y = header.offsetHeight + 4;
			const current = probes.find((el) => {
				const r = el.getBoundingClientRect();
				return r.top <= y && r.bottom > y;
			});
			if (current) header.classList.toggle('on-dark', current.getAttribute('data-header') === 'dark');
		}
		update();
		window.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);
	}

	function initScrollState() {
		const links = header.querySelector('.nav-links');
		let lastY = window.scrollY;
		let queued = false;

		function update() {
			const y = window.scrollY;
			const busy = (links && links.classList.contains('open')) || header.matches(':hover') || header.matches(':focus-within');

			header.classList.toggle('is-scrolled', y > 8);

			if (y <= header.offsetHeight || y < lastY - 6 || busy) {
				header.classList.remove('is-hidden');
			} else if (!reduced && y > lastY + 6 && y > header.offsetHeight * 2) {
				header.classList.add('is-hidden');
			}
			if (Math.abs(y - lastY) > 6) lastY = y;
		}

		update();
		window.addEventListener('scroll', () => {
			if (queued) return;
			queued = true;
			requestAnimationFrame(() => { queued = false; update(); });
		}, { passive: true });
	}

	function initScrollProgress() {
		const bar = document.createElement('div');
		bar.className = 'scroll-progress';
		header.appendChild(bar);
		function update() {
			const h = document.documentElement;
			const max = (h.scrollHeight - h.clientHeight) || 1;
			bar.style.width = (Math.min(1, h.scrollTop / max) * 100) + '%';
		}
		let queued = false;
		update();
		window.addEventListener('scroll', () => {
			if (queued) return;
			queued = true;
			requestAnimationFrame(() => { queued = false; update(); });
		}, { passive: true });
		window.addEventListener('resize', update);
	}

	function boot() {
		setHeaderHeight();
		initNav();
		initMenus();
		initHeaderTheme();
		initScrollState();
		initScrollProgress();
	}
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
	else boot();
})();
